import { FC, useState, useEffect } from 'react';
import cx from 'classnames/bind';

import { Timer } from '@/components/Timer';
import { ModalTimeIsUp } from '@/components/Modal/ModalTimeIsUp';
import { ModalIncorrectOrder } from '@/components/Modal/ModalIncorrectOrder';
import { ModalCorrectOrder } from '@/components/Modal/ModalCorrectOrder';
import { Form } from '@/components/Game/Form';
import { Cigarette } from '@/components/Game/Cigarette';
import type { IBox, IBoxes } from '@/types/pack';
import type { IIdsSelectedCheckboxes } from '@/types/idsSelectedCheckboxes';

import styles from './Step2.module.scss';

interface Step2Props {
  configId: string;
  userToken: string;
  idPack: number;
  setStep: (value: number) => void;
  timer: number;
  totalPoints: number;
  setIsNotification: (value: boolean) => void;
  packs?: IBoxes[];
  points: number;
  pack?: IBox;
  setPack: (value: IBox) => void;
  isViewModal?: boolean;
  firstPlay: boolean;
  setFirstPlay: (value: boolean) => void;
}

const cn = cx.bind(styles);

const Step2: FC<Step2Props> = ({
  configId,
  userToken,
  idPack,
  setStep,
  timer,
  totalPoints,
  setIsNotification,
  packs,
  points,
  pack,
  setPack,
  isViewModal,
  firstPlay,
  setFirstPlay,
}) => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState({
    formats: 0,
    bag: 0,
    filter: 0,
  });
  const [idsSelectedCheckboxes, setIdsSelectedCheckboxes] =
    useState<IIdsSelectedCheckboxes>({
      capsules: [],
      peculiarities: [],
    });

  const [modal, setModal] = useState('');
  const [correctAnswers, setCorrectAnswers] = useState<string[]>([]);

  const [cursor, setCursor] = useState('');

  useEffect(() => {
    if (modal !== '' && cursor !== '') {
      setCursor('');
    }
  }, [modal, cursor]);

  useEffect(() => {
    fetch(`https://admin.znatok.jti-games.dev.familyagency.ru/api/orders/${idPack}`, {
      headers: {
        UserToken: userToken,
      },
    })
      .then((response) => response.json())
      .then(({ data }) => setPack(data));
  }, []);

  const firstList = packs?.[0]?.orders;
  const secondList = packs?.[1]?.orders;
  const thirdList = packs?.[2]?.orders;

  const list = [
    ...(firstList || []),
    ...(secondList || []),
    ...(thirdList || []),
  ];

  const isFirstGame = list?.every(({ achievement }) => achievement === null);
  const isAllPointsReceived = list?.every(
    ({ achievement }) => achievement !== null,
  );

  useEffect(() => {
    if (isFirstGame) {
      setCursor('cursor1');
    }
  }, []);

  return pack ? (
    <div className={cn('container')}>
      {/* Модальное окно "Время на сборку заказа закончилось" */}
      <ModalTimeIsUp
        modal={modal}
        setModal={setModal}
        setStep={setStep}
        setFirstPlay={setFirstPlay}
      />
      {/* Заказ собран неверно */}
      <ModalIncorrectOrder
        modal={modal}
        setModal={setModal}
        setStep={setStep}
        cigarettes={pack.pack.text}
        answers={correctAnswers}
      />
      {/* Заказ собран верно */}
      <ModalCorrectOrder
        modal={modal}
        setModal={setModal}
        setStep={setStep}
        cigarettes={pack.pack.text}
        answers={correctAnswers}
      />

      <div className={cn('container-timer')}>
        <Timer
          title={pack.pack.text}
          src={pack.pack.image}
          setModal={setModal}
          timer={timer}
          modal={modal}
        />
      </div>
      <Cigarette
        idsSelectedCheckboxes={idsSelectedCheckboxes}
        currentSlideIndex={currentSlideIndex}
        pack={pack.pack}
      />
      <Form
        configId={configId}
        userToken={userToken}
        idPack={idPack}
        totalPoints={totalPoints}
        setIsNotification={setIsNotification}
        currentSlideIndex={currentSlideIndex}
        setCurrentSlideIndex={setCurrentSlideIndex}
        setModal={setModal}
        pack={pack}
        setCorrectAnswers={setCorrectAnswers}
        idsSelectedCheckboxes={idsSelectedCheckboxes}
        setIdsSelectedCheckboxes={setIdsSelectedCheckboxes}
        cursor={cursor}
        setCursor={setCursor}
        points={points}
        isViewModal={isViewModal}
        isAllPointsReceived={isAllPointsReceived}
        firstPlay={firstPlay}
      />
    </div>
  ) : null;
};

export default Step2;
